import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const DeleteResellerDialog = ({ reseller, resellers, onOpenChange, onConfirm, deleting }) => {
  const [target, setTarget] = useState("");
  useEffect(() => { setTarget(""); }, [reseller]);
  if (!reseller) return null;
  const n = reseller.customers_count || 0;
  const options = resellers.filter((r) => r.id !== reseller.id && !r.blocked);
  const name = reseller.company?.ragione_sociale || reseller.email;

  return (
    <Dialog open={!!reseller} onOpenChange={onOpenChange}>
      <DialogContent data-testid="delete-reseller-dialog">
        <DialogHeader><DialogTitle>Cancellare {name}?</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-slate-600">Vengono rimossi la scheda, i prodotti assegnati e i piani provvigionali. Le provvigioni già maturate restano nello storico. L'operazione non si può annullare.</p>
          {n > 0 && (
            <div>
              <Label className="text-xs">Il rivenditore ha {n} {n === 1 ? "cliente" : "clienti"}: a chi li trasferisco?</Label>
              <Select value={target} onValueChange={setTarget}>
                <SelectTrigger data-testid="delete-transfer-target"><SelectValue placeholder="Scelga il rivenditore di destinazione" /></SelectTrigger>
                <SelectContent>{options.map((r) => <SelectItem key={r.id} value={r.id}>{r.company?.ragione_sociale || r.email} ({r.codice_reseller})</SelectItem>)}</SelectContent>
              </Select>
              {options.length === 0 && <p className="text-xs text-rose-700 mt-1">Nessun altro rivenditore attivo: non è possibile cancellarlo.</p>}
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button disabled={deleting || (n > 0 && !target)} onClick={() => onConfirm(target)} className="bg-rose-700 hover:bg-rose-800 text-white" data-testid="delete-reseller-confirm">Cancella rivenditore</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
